import { create } from "zustand";

// Contador global de não lidas exibido no badge da sidebar.
// `count` = número de CONVERSAS com mensagens não lidas (não a soma de
// mensagens). Alimentado por [[useWhatsappUnreadCount]] via evento SSE
// `unread_count` do chat v2 (seed na conexão + a cada mudança), montado em toda
// tela autenticada pelo WhatsappUnreadWatcher no ProtectedRoute.
// `undefined` até o seed chegar pelo SSE (badge não renderiza).
type UnreadMessageCountStore = {
  count: number | undefined;
  setCount: (count: number) => void;
};

export const useUnreadMessageCountStore = create<UnreadMessageCountStore>(
  set => ({
    count: undefined,
    setCount: count => set({ count }),
  })
);
